import { render, staticRenderFns } from "./cow-lactation.vue?vue&type=template&id=c617a72a&scoped=true&"
import script from "./cow-lactation.vue?vue&type=script&lang=js&"
export * from "./cow-lactation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c617a72a",
  null
  
)

export default component.exports